import { generic_server, private_server } from '../../utils/axios';
import { CURRENCY } from '../../utils/enums';
import { fileTypeByUrl } from '../../utils/files';


const useOrder = () => {   

    const actions = {
        onGetAll: async(params) => {
            let result = {
                data:[], 
                count:0
            }
            const request = await private_server.get(`/order/list`, {params:{...params}})
            result.data = request.data.data.orders
            result.count = request.data.data.count
            return result
        },
        onGet: async(orderid) => {
            let result = null
            const request = await private_server.get(`/order/${orderid}`)
            result = request.data.data.order
            return result
        },
        onDeleteOrder: async(orderid) => {
            await private_server.delete(`/order/${orderid}/template`)
        },
        onAddTemplate: async(data2send) => {
            let result = null
            const request = await private_server.post('/order/template/me', {currency_id: CURRENCY.MXN, ...data2send})
            result = request.data.data.order_id
            return result
        },
        onEdit: async(orderid, userid, data2send) => {
            await private_server.patch(`/order/${userid}/${orderid}`, data2send)
        },
        onAssignUser: async(orderid, data2send) => {
            await private_server.post(`order/me/assign/${orderid}/template`, data2send)
        },
        onShip: async(orderid, data2send) => {
            await private_server.post(`order/${orderid}/ship`, data2send)
        },
        onUpdateShip: async(orderid, data2send) => {
            await private_server.post(`order/${orderid}/ship/update`, data2send)
        },
        onSetPendingShipment: async(orderid) => {
            await private_server.post(`order/${orderid}/setpendingshipment`)
        },
        onDeliver: async(orderid) => {
            await private_server.post(`order/${orderid}/deliver`)
        },
        onUndeliver: async(orderid) => {
            await private_server.post(`order/${orderid}/undeliver`)
        },
        onUpdateFile: async(iduser, idorder, name, file) => {
            const fType = fileTypeByUrl(file.name)
            let data2send = {type:fType}
            data2send.name = name
            const options = {headers: {'Content-Type': file.type}}
            const response = await private_server.post(`/order/${iduser}/${idorder}/file`, data2send)
            console.log(response.data.data)
            await generic_server.put(response.data.data.upload_url, file, options);
        },
        
    }

    return {
        actions
    }
}
 
export default useOrder;